// Batch 35 · fork X — P53-R5: a part of a long document did not answer within its time limit; the whole read is stopped
// ("part_timeout"). Shown by extractionReasonText (lib/i18n/1280_b34e.js) under b34e.extractReason. EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B35X = {
  en: {
    b34e: {
      extractReason: {
        part_timeout: "A part of this long document took too long to read, so the whole read was stopped and nothing from it was kept — retry, or upload the pages that hold the figures as a separate file.",
      },
    },
  },
  ar: {
    b34e: {
      extractReason: {
        part_timeout: "استغرقت قراءة جزء من هذا المستند الطويل وقتاً أطول من المسموح، فأُوقفت القراءة كلها ولم يُحفظ منها شيء — أعد المحاولة، أو ارفع الصفحات التي تحتوي الأرقام كملف منفصل.",
      },
    },
  },
};

export default I18N_B35X;
